module.exports = __webpack_public_path__ + "img/calendario-black.a80abc89.svg";